module.exports = __webpack_public_path__ + "static/img/bg-gz.84848ffc.jpg";